export default "__VITE_ASSET__CHtICYK3__"